export default "__VITE_ASSET__20615123__"